exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".thumbnail{max-height:256px}.border{padding:10px;border:1px solid #b3b3b3;border-bottom:0;border-radius:.25rem;min-height:65px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/main/webapp/app/components/generic/file-input/file-input.component.css
// module id = 211
// module chunks = 0